import { Link } from "react-router-dom";
import { Plus, ChevronRight } from "lucide-react";
import { PageHeader, Loader, EmptyState } from "@/components/common/Loader";
import { TicketStatusBadge } from "@/components/common/Badges";
import { useFetch } from "@/lib/api";
import { fmtDate, fmtDateTime } from "@/lib/format";

export default function Tickets() {
  const { data, loading } = useFetch("/tickets");
  const newBtn = (
    <Link to="/assistenza/nuovo" data-testid="open-ticket-btn" className="btn-gold"><Plus className="w-4 h-4" /> Apri un ticket</Link>
  );
  return (
    <div>
      <PageHeader eyebrow="Assistenza" title="Siamo qui per te" subtitle="Scrivici per qualsiasi necessità: ti risponderemo il prima possibile, direttamente qui." actions={newBtn} />
      {loading ? <Loader /> : !data?.length ? (
        <EmptyState title="Nessuna richiesta, per ora" text="Quando aprirai un ticket, troverai qui tutta la conversazione con il team Skin Lovers." />
      ) : (
        <div className="space-y-3" data-testid="ticket-list">
          {data.map((t) => (
            <Link key={t.id} to={`/assistenza/${t.id}`} data-testid={`ticket-item-${t.code}`} className="lux-card-link p-5 sm:p-6 flex items-center gap-4">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 flex-wrap">
                  <span className="text-xs tracking-[0.12em] text-warm-text">{t.code}</span>
                  <TicketStatusBadge status={t.status} />
                </div>
                <p className="font-serif text-xl mt-1.5 truncate">{t.subject}</p>
                <p className="text-xs text-warm-text mt-1">{t.category_name} · Aperto il {fmtDate(t.created_at)} · Ultimo aggiornamento {fmtDateTime(t.last_message_at)}</p>
              </div>
              <ChevronRight className="w-4 h-4 text-warm shrink-0" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
